<template>
    <div id="pillar" :style="{ height: '100%'}"></div>
</template>
<script >
import { cmsSysCloudlsdCountEnterprise } from '../../../../api/home.js';

export default {
    name: "",
    components: {},
    props: ['intervalRefreshDate'],

    data() {
        return {
            timer:null
        };
    },
    watch: {},
    computed: {},
    methods: {
        async drawLine() {
            // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
            let myChart = this.$echarts.init(document.getElementById('pillar'))
            // 绘制图表
            let nameList = [], add = [], all = []
            try {
                const res = await cmsSysCloudlsdCountEnterprise()
                res.data.forEach((item, index) => {
                    const { enterpriseAddAmount, enterpriseAmount, city } = item
                    //城市名
                    nameList.push(city)
                    //新增数据
                    add.push(enterpriseAddAmount)
                    //全部数据
                    all.push(enterpriseAmount)

                });
                
            } catch (err) {
                this.$message.error("数据加载失败")

            }
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },

                },
                legend: {
                    top: '3%',
                    textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                        color: '#9FB7DF'
                    }

                },

                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                yAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01],
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                            color: '#9FB7DF'
                        }
                    },
                    axisLabel: {           // 坐标轴文本标签，详见axis.axisLabel
                        show: true,
                        interval: 'auto',
                        rotate: 0,
                        margin: 8,
                        // formatter: null,
                        textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                            color: '#9FB7DF'
                        }

                    }
                },
                xAxis: {
                    type: 'category',
                    data: nameList,
                    axisLabel: {           // 坐标轴文本标签，详见axis.axisLabel
                        show: true,
                        interval: 'auto',
                        rotate: 0,
                        margin: 8,
                        // formatter: null,
                        textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                            color: '#9FB7DF'
                        }

                    }
                },
                series: [
                    {
                        name: '新增',
                        type: 'bar',
                        barWidth: 15,
                        barGap: '70%',/*多个并排柱子设置柱子之间的间距*/
                        show:false,
                        itemStyle: {
                            normal: {
                                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: '#d25dff',
                                    },
                                    {
                                        offset: 1,
                                        color: '#d25dff',
                                    },
                                ]),
                                barBorderRadius: 2,
                            },
                        },
                        label: {
                            show: true,
                            position: 'top',
                            textStyle: {
                                color: '#9FB7DF'
                            }
                        },
                        data: add,
                    },
                    {
                        name: '全部',
                        type: 'bar',
                        barWidth: 15,
                        itemStyle: {
                            normal: {
                                // color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                //     {
                                //         offset: 0,
                                //         color: '#89aec1',

                                //     },
                                //     {
                                //         offset: 1,
                                //         color: '#143485',
                                //     },
                                // ]),
                                barBorderRadius: 2,
                            },
                        },
                        label: {
                            show: true,
                            position: 'top',
                            textStyle: {
                                color: '#9FB7DF'
                            }
                        },
                        data: all,
                    },
                ],
            };





            myChart.clear();
            myChart.setOption(option);
        }
    },
    created() { },
    async mounted() {
        await this.drawLine();
       this.timer = setInterval(async () => {
        await this.drawLine();
        }, this.intervalRefreshDate)
       

    },
    beforeDestroy() {
        console.log("销毁定时器")
        //2.销毁前清除定时器
        clearInterval(this.timer);
    },
}
</script>
<style lang="scss" scoped>

</style>